import React from 'react';
import {StyleSheet, TouchableOpacity, Image} from 'react-native';
import ToastPopup from '../../HelperClasses/AppLoaderClasses/ToastPopup';
import deleteIcon from '../../assets/delete_icon.png';
import TableCommonStyleSheet from '../../StyleSheets/TableCommonStyleSheet';
import {useLocale} from '../../Localization/LocaleContext';
import RolePermissionContext from '../../Component/RolePermissionContext';

const DeleteButton = ({onClickDelete}) => {
  const {translate} = useLocale();
  return (
    <RolePermissionContext.Consumer>
      {permission => {
        const disabled = permission?.deleteP === false;
        return (
          <TouchableOpacity
            accessibilityRole="button"
            accessibilityLabel={translate("common.delete")}
            onPress={onClickDelete}
            disabled={disabled}
            style={{opacity: disabled ? 0.45 : 1}}>
            <Image
              style={TableCommonStyleSheet.iconStyle}
              resizeMode="center"
              source={deleteIcon}
            />
          </TouchableOpacity>
        );
      }}
    </RolePermissionContext.Consumer>
  );
};

export default DeleteButton;
